import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import isNumber from 'lodash/isNumber';

import { updateProductAction } from 'store/actions/listsActions';
import { getPriceByPercent } from 'utils/helpers';
import { IWithProps, TProps } from 'components/ProductsEditMap/constants';
import { EEditType } from 'types/commonEnums';

export default (Component: FC<IWithProps>) => ({
  ids = [],
  mapPercent = 0,
  priceFrom = 0,
  priceTo = 0,
  onModalClose = () => {},
}: TProps) => {
  const dispatch = useDispatch();
  const [percent, setPercent] = useState<any>(mapPercent);
  const mapFrom = getPriceByPercent(priceFrom, percent);
  const mapTo = getPriceByPercent(priceTo, percent);

  const handleSubmit = () => {
    dispatch(updateProductAction({ ids, type: EEditType.Edit, mapPercent: percent, mapFrom, mapTo }));
    onModalClose();
  };

  const inputs = [
    {
      span: 12,
      label: 'Selling Price $',
      value: `${priceFrom}-${priceTo}`,
      disabled: true,
      tooltip: 'Calculation of MAP is based on price for the dropshipper',
    },
    { span: 12, label: 'Minimum Advertising Price $', value: `${mapFrom}-${mapTo}`, disabled: true },
    {
      span: 24,
      label: 'MAP %',
      value: percent,
      onChange: setPercent,
      placeholder: 'Enter MAP %',
      min: 0,
      max: 99,
      maxLength: 2,
    },
  ];

  return <Component inputs={inputs} isDisabled={!isNumber(percent)} onSubmit={handleSubmit} />;
};
